import { mapDeverbIntensityLevelFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { DeverbChannel } from '../../api';
import { DeverbChanelFragment } from '../graphql/generated/deverb.generated';

export function mapDeverbChannelFromSysApi(channel: DeverbChanelFragment): DeverbChannel {
	const { id, description, features } = channel;
	return {
		id,
		name: channel.features.name?.name,
		constraints: {
			deverb: {
				supportedIntensity:
					description.constraints.deverb?.intensity.options.map((option) =>
						mapDeverbIntensityLevelFromSysApi(option)
					) ?? []
			}
		},
		features: {
			deverb: {
				enabled: features.deverb?.enabled || false,
				intensity: mapDeverbIntensityLevelFromSysApi(features.deverb?.intensity)
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		}
	};
}
